import { useRef, useState } from "react";
import { Animated, ScrollView, ScrollViewProps, View } from "react-native";
import styles from './CustomScrollView.jss';
import { Device } from "DeviceUtils";

interface CustomScrollviewWithScrollBar extends Omit<ScrollViewProps, 'showsVerticalScrollIndicator' | 'onLayout' | 'onScroll' | 'onContentSizeChange'> { }

const CustomScrollviewWithScrollBar = (props: CustomScrollviewWithScrollBar) => {
    const [completeScrollBarHeight, setCompleteScrollBarHeight] = useState(1);
    const [visibleScrollBarHeight, setVisibleScrollBarHeight] = useState(0);
    const scrollIndicator = useRef(new Animated.Value(0)).current;

    const scrollIndicatorSize =
        completeScrollBarHeight > visibleScrollBarHeight
            ? (visibleScrollBarHeight * visibleScrollBarHeight)
            / completeScrollBarHeight
            : visibleScrollBarHeight;
    const difference =
        visibleScrollBarHeight > scrollIndicatorSize
            ? visibleScrollBarHeight - scrollIndicatorSize
            : 1;
    const scrollIndicatorPosition = Animated.multiply(
        scrollIndicator,
        visibleScrollBarHeight / completeScrollBarHeight,
    ).interpolate({
        extrapolate: 'clamp',
        inputRange: [0, difference],
        outputRange: [0, difference],
    });

    const onContentSizeChange = (_, contentHeight) =>
        setCompleteScrollBarHeight(contentHeight);
    const onLayout = ({
        nativeEvent: {
            layout: { height },
        },
    }) => {
        setVisibleScrollBarHeight(height);
    };
    return (
        <View style={styles.scrollContainer}>
            <ScrollView
                onContentSizeChange={onContentSizeChange}
                onLayout={onLayout}
                onScroll={Animated.event(
                    [{ nativeEvent: { contentOffset: { y: scrollIndicator } } }],
                    { useNativeDriver: false },
                )}
                scrollEventThrottle={16}
                showsVerticalScrollIndicator={false}
                style={styles.scrollViewContainer}
                {...props}
                contentContainerStyle={[{ paddingRight: 14 }, props.contentContainerStyle,
                Device.isTablet && Device.isIos ? undefined : completeScrollBarHeight === visibleScrollBarHeight ? { paddingRight: 0 } : undefined
                ]}
            >
                {props.children}
            </ScrollView>
            <View style={[styles.customScrollBarBackground,
            { display: completeScrollBarHeight === visibleScrollBarHeight ? 'none' : 'flex' }]
            }>
                <Animated.View
                    style={[
                        styles.customScrollBar,
                        {
                            height: scrollIndicatorSize,
                            transform: [{ translateY: scrollIndicatorPosition }],
                        },
                    ]}
                />
            </View>
        </View>
    );
};

export default CustomScrollviewWithScrollBar;